// extracted by mini-css-extract-plugin
export default {"block":"inputWrapper_block__nWoTX","labelItem":"inputWrapper_labelItem__q9Mu2","errorTextColor":"inputWrapper_errorTextColor__YeacC","close":"inputWrapper_close__DAETg"};